import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import { protectedResources } from "../../authConfig";
import { managerDashboards } from "../../config/managerDashboards";
import AppsGrid from "../HomePage/components/AppsGrid";

const handleExternalClick = (url) => {
  if (!url) return;
  window.location.href = url;
};

const ManagersDashboardHome = () => {
  const { execute } = useFetchWithMsal({ scopes: protectedResources.apiScopes.scopes.read });
  const [access, setAccess] = useState(null);

  useEffect(() => {
    const fetchAccess = async () => {
      try {
        const result = await execute(
          "GET",
          `${process.env.REACT_APP_BACKEND_BASE_URL}/api/managerDashboard/myAccess`,
        );
        setAccess(result);
      } catch (err) {
        setAccess({ isAdmin: false, allowedDashboards: [] });
      }
    };
    fetchAccess();
  }, [execute]);

  if (!access) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  const visibleDashboards = managerDashboards
    .filter((dashboard) => access.isAdmin || access.allowedDashboards.includes(dashboard.key))
    .map((dashboard) => ({
      id: dashboard.key,
      label: dashboard.label,
      icon: dashboard.icon,
      iconColor: dashboard.iconColor,
      gradient: dashboard.gradient,
      shadowColor: dashboard.shadowColor,
      isExternal: !dashboard.path,
      path: dashboard.path,
      externalUrl: dashboard.externalUrl,
      openInNewTab: dashboard.openInNewTab,
    }));

  if (visibleDashboards.length === 0) {
    return (
      <Typography color="text.secondary">
        אין לך גישה לאף דשבורד כרגע. פנה/י למנהל המערכת לקבלת הרשאה.
      </Typography>
    );
  }

  return <AppsGrid cards={visibleDashboards} onExternalAppClick={handleExternalClick} />;
};

export default ManagersDashboardHome;
